export default __webpack_public_path__ + "static/media/jJPY.2dd3e504.png";